import { writable } from "svelte/store";

export const showProjectsAddLicensesModalStore = writable(null);
